export default {
  apiAddress: 'api/ccservice',
  devApiAddress: 'https://c1ccservice.kjtpay.com/ccservice', // 'http://192.168.170.218:8080/ccservice','http://192.168.23.171:8080/ccservice',//
  gatewayApiAdress: "gatewayinner",
  devGatewayAddress: "/gatewayinner",
};



// WEBPACK FOOTER //
// ./src/model/config.js